import React from 'react';
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function NavbarToggleButton({toggleNavbar}) {

    return (
        <IconButton
            size="large"
            color="inherit"
            type='button'
            onClick={toggleNavbar}
            style={squareHighlightStyle}
        >
            <MenuIcon/>
        </IconButton>
    );
}
